import Vue from 'vue'
import Router from 'vue-router'
import ThePage from '@/components/ThePage'
import TheAuthorPage from '@/components/TheAuthorPage'
import store from '@/store'

Vue.use(Router)
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      meta: {
        title: '有看投_让投资大有看头_第一财经'
      },
      component: ThePage,
      children: [
        {
          path: 'course',
          component: () => import('@/views/Course'),
          meta: {
            title: '课程_有看投_让投资大有看头_第一财经'
          }
        },
        {
          path: 'course/:id',
          component: () => import('@/views/CourseDetail')
        },
        {
          path: 'jinNang',
          component: () => import('@/views/JinNang'),
          meta: {
            title: '锦囊_有看投_让投资大有看头_第一财经 '
          }
        },
        {
          path: 'jinNang/:id',
          component: () => import('@/views/JinNangDetail')
        },
        {
          path: '',
          component: () => import('@/views/Home'),
          meta: {
            title: '有看投_让投资大有看头_第一财经'
          }
        },
        {
          path: 'author',
          component: () => import('@/views/Author'),
          meta: {
            title: '大咖_有看投_让投资大有看'
          }
        },
        {
          path: 'author/:id',
          component: () => import('@/views/AuthorDetail')
        },
        {
          path: 'mine',
          component: () => import('@/views/Mine'),
          meta: {
            title: '个人信息_有看投_让投资大有看头_第一财经',
            auth: true
          },
          children: [
            {
              path: '',
              component: () => import('@/components/Mine/MyPurchase.vue'),
              meta: {
                title: '我购买的服务_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'purchase',
              component: () => import('@/components/Mine/MyPurchase.vue'),
              meta: {
                title: '我购买的服务_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'info',
              component: () => import('@/components/Mine/MineInfo.vue'),
              meta: {
                title: ''
              }
            },
            {
              path: 'vcurrency',
              component: () => import('@/components/Mine/VCurrency.vue'),
              meta: {
                title: '我的财币_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'coupon',
              component: () => import('@/components/Mine/MyCoupon.vue'),
              meta: {
                title: '优惠券_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'follow',
              component: () => import('@/components/Mine/Follow.vue'),
              meta: {
                title: '我的关注_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'orders',
              component: () => import('@/components/Mine/MyOrders.vue'),
              meta: {
                title: '我的订单_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'purchase',
              component: () => import('@/components/Mine/MyPurchase.vue'),
              meta: {
                title: '我购买的服务_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'feedback',
              component: () => import('@/components/Mine/Feedback.vue'),
              meta: {
                title: '意见反馈_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'browse',
              component: () => import('@/components/Mine/MyBrowse.vue'),
              meta: {
                title: '浏览记录_有看投_让投资大有看头_第一财经'
              }
            }
          ]
        },
        {
          path: 'dianjin',
          component: () => import('@/views/DianJin'),
          meta: {
            title: '大咖_有看投_让投资大有看'
          }
        },
        {
          path: 'dianjin/:id',
          component: () => import('@/views/DianJinDetail')
        }
      ]
    },
    {
      path: '/cashier-desk',
      meta: {
        title: '有看投-收银台'
      },
      component: () => import('@/views/CashierDesk')
    },
    {
      path: '/author-course',
      meta: {
        title: '有看投-大咖课程管理',
        auth: true,
        needAuthorRole: true
      },
      component: () => import('@/components/AuthorCourse/CoursePage'),
      children: [
        {
          path: '',
          component: () => import('@/views/AuthorCourse')
        },
        {
          path: '/new-course',
          component: () => import('@/views/NewCourse')
        },
        {
          path: ':id',
          component: () => import('@/views/AuthorCourseRelevance')
        }
      ]
    },
    {
      path: '/excl-author/',
      meta: {
        title: '有看投-大咖认证'
      },
      component: TheAuthorPage,
      children: [
        {
          path: '',
          component: () => import('@/views/AuthorLogin'),
          meta: {
            title: '有看投_大咖_登录',
            AuthorLoginPage: true
          }
        },
        {
          path: 'pwd-retrieve',
          component: () => import('@/views/PassWordRetrieve'),
          meta: {
            title: '有看投_大咖_找回密码'
          }
        },
        {
          path: 'pwd-set',
          component: () => import('@/views/PassWordSet'),
          meta: {
            title: '有看投_大咖_设置密码',
            auth: true,
            needNewAuthorRole: true
          }
        },
        {
          path: 'regist',
          component: () => import('@/views/AuthorRegist'),
          meta: {
            title: '有看投_大咖_认证'
          }
        },
        {
          path: 'mine',
          component: () => import('@/views/AuthorMine'),
          meta: {
            title: '有看投_大咖_我的',
            auth: true,
            needNewAuthorRole: true
          }
        },
        {
          path: 'dianjin',
          component: () => import('@/views/AuthorDianJin'),
          meta: {
            title: '有看投_大咖_点金',
            auth: true,
            needNewAuthorRole: true
          },
          children: [
            {
              path: '',
              component: () => import('@/components/AuthorDianJin/Publish.vue'),
              meta: {
                title: '有看投_大咖_点金_发布点金',
                auth: true,
                needNewAuthorRole: true
              }
            },
            {
              path: 'published',
              component: () =>
                import('@/components/AuthorDianJin/Published.vue'),
              meta: {
                title: '有看投_大咖_点金_已发布的点金',
                auth: true,
                needNewAuthorRole: true
              }
            },
            {
              path: 'payment',
              component: () => import('@/components/AuthorDianJin/Payment.vue'),
              meta: {
                title: '有看投_大咖_点金_付费点金',
                auth: true,
                needNewAuthorRole: true
              },
              children: [
                {
                  path: '',
                  component: () =>
                    import('@/components/AuthorDianJin/PaymentDetai.vue'),
                  meta: {
                    title: '有看投_大咖_点金_点金收费申请',
                    auth: true,
                    needNewAuthorRole: true
                  }
                },
                {
                  path: 'apply',
                  component: () =>
                    import('@/components/AuthorDianJin/FeeApplication.vue'),
                  meta: {
                    title: '有看投_大咖_点金_点金收费申请',
                    auth: true,
                    needNewAuthorRole: true
                  }
                },
                {
                  path: 'apply-result',
                  component: () =>
                    import(
                      '@/components/AuthorDianJin/FeeApplicationResult.vue'
                    ),
                  meta: {
                    title: '有看投_大咖_点金_点金收费申请',
                    auth: true,
                    needNewAuthorRole: true
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'jinnang',
          meta: {
            title: '有看投-大咖锦囊',
            auth: true,
            needNewAuthorRole: true
          },
          component: () => import('@/views/AuthorJinNangLevelOneContainer'),
          children: [
            {
              path: '',
              meta: {
                title: '有看投-大咖锦囊列表',
                auth: true,
                needNewAuthorRole: true
              },
              component: () => import('@/views/AuthorJinNangIndex')
            },
            {
              path: 'apply',
              component: () =>
                import('@/components/AuthorJinNang/JinNangApplication.vue'),
              meta: {
                title: '有看投-大咖锦囊申请-填写资料'
              }
            },
            {
              path: 'apply-result',
              component: () =>
                import('@/components/AuthorJinNang/ApplicationResult.vue'),
              meta: {
                title: '有看投-大咖锦囊申请-申请结果'
              }
            }
          ]
        },
        {
          path: 'jinnang/:id',
          meta: {
            title: '有看投-大咖锦囊详情',
            auth: true,
            needNewAuthorRole: true
          },
          component: () => import('@/views/AuthorJinNangPage'),
          children: [
            {
              path: 'cancle',
              component: () =>
                import('@/components/AuthorJinNang/JinNangCancle.vue'),
              meta: {
                title: '撤单_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'repo',
              component: () =>
                import('@/components/AuthorJinNang/JinNangRepo.vue'),
              meta: {
                title: '资金持仓_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'sale',
              component: () =>
                import('@/components/AuthorJinNang/JinNangSale.vue'),
              meta: {
                title: '卖出_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'buy',
              component: () =>
                import('@/components/AuthorJinNang/JinNangBuy.vue'),
              meta: {
                title: '买入_有看投_让投资大有看头_第一财经'
              }
            },
            {
              path: 'query',
              component: () =>
                import('@/components/AuthorJinNang/JinNangQuery.vue'),
              meta: {
                title: '查询_有看投_让投资大有看头_第一财经'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/excl-author/course/',
      meta: {
        title: '有看投_大咖_课程',
        auth: true,
        needNewAuthorRole: true
      },
      component: TheAuthorPage,
      children: [
        {
          path: '',
          component: () => import('@/views/AuthorCourse')
        },
        {
          path: 'new-course',
          component: () => import('@/views/NewCourse')
        },
        {
          path: ':id',
          component: () => import('@/views/AuthorCourseRelevance')
        },
        {
          path: 'comment/:id',
          component: () => import('@/views/AuthorCourseComment')
        }
      ]
    },
    {
      path: '/excl-author/agreement/privacy',
      meta: {
        title: '有看投_大咖_隐私协议'
      },
      component: () => import('@/views/Agreement/Privacy.vue')
    },
    {
      path: '/excl-author/agreement/Regist',
      meta: {
        title: '有看投_大咖_使用协议'
      },
      component: () => import('@/views/Agreement/Regist.vue')
    },
    {
      path: '/popularize',
      name: 'popularize',
      component: () => import('@/views/Popularize'),
      meta: {
        title: '有看投推广'
      }
    }
  ]
})
/**
 * 权限验证
 */
router.beforeEach((to, from, next) => {
  // 登录页判断
  if (
    to.matched.some(r => r.meta.AuthorLoginPage) &&
    store.getters['auth/isLogin']
  ) {
    // 若已登录，跳转至个人中心
    router.push('/excl-author/mine')
  } else if (to.matched.some(r => r.meta.auth)) {
    if (store.getters['auth/isLogin']) {
      // 已登录，判断是否需要大咖身份
      if (
        to.matched.some(r => r.meta.needAuthorRole || r.meta.needNewAuthorRole)
      ) {
        if (store.getters['user/isAuthor']) {
          next()
        } else {
          store.dispatch('/')
          // 非大咖身份，跳转到注册页
          // router.push('/excl-author/regist')
        }
      }
      next()
    } else {
      // 未登录，跳转
      if (to.matched.some(r => r.meta.needNewAuthorRole)) {
        // 跳转大咖登录
        router.push('/excl-author')
      } else {
        store.dispatch('auth/login')
      }
    }
  } else {
    next()
  }
})

// 使用afterEach钩子函数，保证路由跳转成功之后修改title
router.afterEach(route => {
  let documentTitle = ''

  route.matched.forEach(path => {
    if (path.meta.title) {
      documentTitle = path.meta.title
    }
  })

  if (documentTitle) {
    document.title = documentTitle
  }
})

export default router
